$(document).ready(function()  {
                 var settings = {
                  "url": "https://api.getgreenspark.com/v2/widgets/full-width-banner?lng=en",
                  "method": "POST",
                  "timeout": 0,
                  "headers": {
                  "X-API-KEY": "EvuDSffE49VWSWsqkRAwnqogvxV3vZS58rXfoAUcVaGhPV10t7lE1barGzvtixxcIdHeeo90i4gPCbwh",
                  "Content-Type": "application/json"
              },
                  "data": JSON.stringify({
                  "shopUniqueName": "artizan-coffee-company-1",
                  "options": [
                  "monthsEarthPositive", 
                  "trees", 
                  "plastic", 
                  "carbon", 
                  "straws", 
                  "miles", 
                  "footballPitches"
              ],
              "imageUrl": "null"
              }),
            };

            $.ajax(settings).done(function (response) {
              $('#shopify-section-template--24432734044433__video_GCA8Jg .content-over-media.full-bleed.text-custom').append(response);
            });
    });  

const options = {
  method: 'POST',
  headers: {
    accept: 'application/json',
    'content-type': 'application/json',
    'x-api-key': '"EvuDSffE49VWSWsqkRAwnqogvxV3vZS58rXfoAUcVaGhPV10t7lE1barGzvtixxcIdHeeo90i4gPCbwh"'
  }
};